import httpService from "./httpService";
import utils from "./utils";

export default {

  search(keyword, ownDeptId, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({keyword: keyword, ownDeptId: ownDeptId}, pageable);
    return httpService.get("otherDepartment/search", {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/otherDepartmentService.js